module.exports = __webpack_public_path__ + "assets/img/item2-bg.06f8ad30.png";